export const editorSelector = (state) => state.editor;
